class AccordionComponent extends HTMLElement {
  constructor() {
    super();
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    this.questions = Array.from(this.querySelectorAll('.new-faq__question'));
    this.questions.forEach((question) => {
      question.addEventListener('click', () => this.toggle(question));
    });

    window.addEventListener('resize', this.onResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
  }

  getAnswer(question) {
    return document.getElementById(question.getAttribute('aria-controls'));
  }

  // Read from CSS so prefers-reduced-motion can drop it to zero in one place.
  getDuration() {
    const value = getComputedStyle(this).getPropertyValue('--accordion-duration').trim();
    const duration = parseFloat(value);
    if (Number.isNaN(duration)) return 300;
    return value.endsWith('ms') ? duration : duration * 1000;
  }

  // Rows open independently: shoppers often compare two answers at once.
  toggle(question) {
    if (question.classList.contains('opened')) {
      this.close(question);
    } else {
      this.open(question);
    }
  }

  open(question) {
    const answer = this.getAnswer(question);
    question.classList.add('opened');
    question.setAttribute('aria-expanded', 'true');
    if (!answer) return;

    const duration = this.getDuration();
    clearTimeout(answer.accordionTimer);
    answer.style.overflow = 'hidden';
    answer.classList.add('opened');
    // Leaving display: none and setting the target height in the same frame skips the transition.
    answer.getBoundingClientRect();
    answer.style.transition = `max-height ${duration}ms ease, opacity ${duration}ms ease`;
    answer.style.maxHeight = `${answer.scrollHeight}px`;
    answer.style.opacity = '1';
    answer.accordionTimer = setTimeout(() => {
      if (question.classList.contains('opened')) answer.style.overflow = 'visible';
    }, duration);
  }

  close(question) {
    const answer = this.getAnswer(question);
    question.classList.remove('opened');
    question.setAttribute('aria-expanded', 'false');
    if (!answer) return;

    const duration = this.getDuration();
    clearTimeout(answer.accordionTimer);
    answer.style.transition = `max-height ${duration}ms ease, opacity ${duration}ms ease`;
    answer.style.overflow = 'hidden';
    answer.style.maxHeight = '0';
    answer.style.opacity = '0';
    answer.accordionTimer = setTimeout(() => {
      if (!question.classList.contains('opened')) answer.classList.remove('opened');
    }, duration);
  }

  // Hidden answers measure 0px, so one resized while hidden stays collapsed until re-measured.
  refresh() {
    this.questions.forEach((question) => {
      if (!question.classList.contains('opened')) return;
      const answer = this.getAnswer(question);
      if (!answer) return;
      answer.style.transition = 'none';
      answer.style.maxHeight = `${answer.scrollHeight}px`;
    });
  }

  onResize() {
    if (this.resizeFrame) return;
    this.resizeFrame = requestAnimationFrame(() => {
      this.resizeFrame = null;
      this.refresh();
    });
  }
}

if (!customElements.get('accordion-component')) {
  customElements.define('accordion-component', AccordionComponent);
}
